import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid } from "@mui/material";
import { useFormik } from "formik";
import { ImportSchema, TextInput } from "./Components";


const Modal = ({
  open,
  data,
  handleCancel,
  handleOk
}) => {

  let defaultFormState = {}

  data && Object.keys(data).forEach(keyName => {
    defaultFormState[keyName] = data[keyName]
  })

  const formik = useFormik({
    initialValues: { ...defaultFormState },
    validationSchema: ImportSchema,
    enableReinitialize: true,
    onSubmit: values => {
      handleOk(values)
    },
  });


  if (!data) {
    return <></>
  }

  const dataKeys = Object.keys(data)
  const fixedKeys = dataKeys.filter(name => ['id', 'uniqueid', 'serialno'].includes(name.toLowerCase())).map(item => item.toLowerCase())

  return (
    <Dialog
      className="relative"
      sx={{ '& .MuiDialog-paper': { width: '90%', maxHeight: '80vh', top: '5vh' } }}
      maxWidth="sm"
      open={open}
    >
      <DialogTitle className="!font-bold !text-[2rem]">Edit</DialogTitle>

      <form onSubmit={formik.handleSubmit} className={`h-full`}>
        <DialogContent>
          <Grid container spacing={2} className="">
            {
              Object.keys(data).map((keyName, index) => {

                const isFixedKey = fixedKeys.includes(keyName.toLowerCase())

                return <Grid item key={index} xs={isFixedKey || (index >= Object.keys(data).length - 4) ? 6 : 12} >
                  <FormControl className={`w-${isFixedKey ? '11/12' : 'full'}`}>
                    <TextInput
                      name={keyName}
                      label={keyName}
                      disabled={isFixedKey}
                      value={formik.values[keyName]}
                      onChange={e => formik.setFieldValue(keyName, e.target.value)}
                      error={formik.errors[keyName]}
                      helperText={formik.errors[keyName]}
                    />
                  </FormControl>
                </Grid>
              })
            }
          </Grid>
        </DialogContent>

        <DialogActions className={`sticky bottom-0 bg-white shadow-[0_-2px_20px_1px_#e0e0e0]`}>
          <Button autoFocus onClick={handleCancel}>
            Cancel
          </Button>
          <Button type='submit'>Ok</Button>
        </DialogActions>

      </form>
    </Dialog>
  );
}

export default Modal;